module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail",
    class: {
      hidden: _vm.category.IsHidden
    }
  }, [_c('div', {
    staticClass: "detailHead",
    attrs: {
      "id": _vm.category.Category.UniqueCategoryName
    }
  }, [_c('img', {
    staticClass: "iconMark",
    attrs: {
      "src": require("../assets/img/marketing standard.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.category.Category.CategoryName) + "\n  ")]), _vm._v(" "), _vm._l((_vm.reports), function(report, index) {
    return _c('report', {
      key: report.ReportId,
      attrs: {
        "report": report,
        "color": _vm.color
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-407e4de4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportCategory.vue
// module id = 479
// module chunks = 2